import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { pullBandit } from 'src/app/shared/api/bandits';

import type { ShareChannel } from '../../types';
import { useGetHeadlineVariant } from '../bandits';

export function usePullBandits() {
	const utilityContext = useUtilityContext();
	const getVariant = useGetHeadlineVariant();

	return useCallback(
		async (channel: ShareChannel) => {
			switch (channel) {
				case 'facebook':
				case 'whatsapp':
				case 'copy':
				case 'twitter': {
					const variant = getVariant(channel);
					if (variant) {
						const { experimentName, variantName } = variant;
						await pullBandit({ experimentName, variantName }, utilityContext, { silent: true });
					}
					break;
				}
				default:
				// do nothing
			}
		},
		[getVariant, utilityContext],
	);
}
